import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../сomponents/Table';
import { push } from 'react-router-redux';
import { getListOfQuotes } from '../../api/archive';
import { reopenArchiveQuote } from '../../api/quotes';
import { find, path, propEq, clone, mergeDeepLeft } from 'ramda';
import { changeModalState } from '../../actions/modal';
import Preloader from '../../common/Preloader';
import ConfirmAction from '../../common/ConfirmAction';
import './style.css';
import { addNotification as notify } from "reapop";
import hasAccess from "../../helpers/permissionChecker";
import fields from './field';
import moment from 'moment';
import DatePicker from "../../common/DatePicker";

export class ArchiveListQuotes extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerReOpen = this.handlerReOpen.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.getArchive = this.getArchive.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.getFilter = this.getFilter.bind(this);
    this.reloadArchive = this.reloadArchive.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      currentPage: 0,
      fields: fields,
      loading: true
    };

    this.columns = [
      'id',
      'name',
      'projectName',
      'created',
    ];

    this.columnNames = [
      'ID#',
      'Quote\'s name',
      'Customer',
      'Created',
    ];
  }

  componentWillReceiveProps (newProps) {
    const itemsList = path(['archive', 'quotes', 'list'], newProps);
    if (itemsList) {
      this.setState({loading: false});
    }
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  componentWillMount() {
    this.reloadArchive();
  }

  applyFilter() {
    this.reloadArchive();
  }

  reloadArchive() {
    const { filter_date_from, filter_date_to } = this.getFilter();
    this.setState({loading: true});
    this.props.loadArchive({filter_date_from, filter_date_to});
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field === 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  getFilter() {
    let dateFrom = this.state.fields['filter_date_from'].value;
    let dateTo = this.state.fields['filter_date_to'].value;
    if (dateTo) {
      dateTo = moment(dateTo).format('M/D/YYYY');
    }

    if (dateFrom) {
      dateFrom = moment(dateFrom).format('M/D/YYYY');
    }

    return {
      filter_date_from: dateFrom || '1/1/1990',
      filter_date_to:  dateTo || moment().add('1', 'year').format('M/D/YYYY'),
    };
  }

  handlerReOpen(id) {
    let itemsList = path(['archive', 'quotes', 'list'], this.props);
    const currentQuote = find(propEq('id', id))(itemsList);
    const quoteAuthor = path(['user_id'], currentQuote);

    this.props.handleModalState({
      permission: { 'permAreaKey': 'quote', 'permTypeKey': 'reOpen' },
      authorId: quoteAuthor,
      isOpen: !this.props.modal.isOpen,
      handler: this.props.reopen,
      id: id,
      modalId: 'reopenQuote',
    });
  }

  handlerEdit(id) {
    this.props.openQuote(id);
  }

  getArchive() {
    // Get current role
    let itemsList = path(['archive', 'quotes', 'list'], this.props);
    let itemActions = {};

    if (!itemsList || itemsList.length === 0) {
      itemsList = [];
    } else {
      itemActions = {
        reopen: {
          handler: this.handlerReOpen,
          itemId: 'id',
          authorColumnName: 'user_id',
          permission: { 'permAreaKey': 'quote', 'permTypeKey': 'reOpen' },
          icon: ['fa fa-circle-thin icon-stack-3x', 'fa ion-android-refresh icon-stack-1x'],
          iconClass: 'remove_circle_outline',
          context: this,
          hasWrapper: true,
          title: 'reopen',
        },
        edit: {
          handler: this.handlerEdit,
          icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
          iconClass: '',
          authorColumnName: 'user_id',
          permission: { 'permAreaKey': 'quote', 'permTypeKey': 'view' },
          context: this,
          itemId: 'id',
          hasWrapper: true,
          title: 'edit',
        },
      };
    }

    return (
      <div>
        <Table
          items={itemsList}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          search={this.state.search}
          actions={itemActions}
          currentPage={this.state.currentPage}
          onChangeCurrentPage={this.onChangeCurrentPage}
          onSearch={this.onSearch}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
        />
      </div>
    );
  }

  render() {
    const archive = this.getArchive();
    let preloader = null;
    const { loading } = this.state;

    if (loading) {
      preloader = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    return (
      <div className="card-block">
        <div className="clearfix mb-3">
          <button
            className="btn btn-rounded btn-icon ui-btn pull-right"
            onClick={this.applyFilter}
            style={{ marginRight: '10px', borderRadius: '4px', }}
          >
            <i className="fa fa-filter"></i>
            Apply filter
          </button>
        </div>
        <div className="row">
          <div className="col col-md-6">
            <DatePicker
              field={this.state.fields['filter_date_from']}
              onChange={this.changeFormValue}
            />
          </div>
          <div className="col col-md-6">
            <DatePicker
              field={this.state.fields['filter_date_to']}
              onChange={this.changeFormValue}
            />
          </div>
        </div>
        <div>
          {archive}
          {preloader}
        </div>
        <ConfirmAction
          id={'reopenQuote'}
          title={'Reopen Item'}
          content={'Are you sure you want to reopen this item?'}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadArchive: (filter) => {
      getListOfQuotes(filter)(dispatch);
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    reopen: (id) => {
      reopenArchiveQuote(id)(dispatch);
    },
    openQuote: (id) => {
      dispatch(push('/pages/quotes-edit/' + id));
    },
    accessDeniedMessage: () => {
      dispatch(notify({
        title: 'Reopen quote',
        message: 'Access denied. Failed to reopen quote.',
        status: 'error',
        position: 'tr',
        dismissible: true,
        dismissAfter: 3000
      }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveListQuotes);



// WEBPACK FOOTER //
// ./src/containers/ArchiveListQuotes/index.js